export const DATA_VALIDATION_V2_POOLING_INTERVAL = 15_000;
